import { HTTP } from './http-common';

export default {
  getGeneralPage(data) {
    return HTTP.get('/qnt/dash/', {params:data});
  },
}